export default `float s=2., e;
    for(int j=0;j++<8;){
      p=.1-abs(p-.2);
      p.x < p.z?p=p.zyx:p;
      s*=e=1.6;
      p=abs(p)*e-vec3(.1,3.0,1.0);
      p.yz*=rotate2D(.8);
    }
    return length(p.yx)/s-.04;
  }`